import { type Editor } from "@tiptap/react";

// --- Icons ---
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faList,
  faListCheck,
  faListOl,
} from "@nnr/fontawesome-sharp-light/icons/sharp/light";

export type ListType = "bulletList" | "orderedList" | "taskList";

interface ListOption {
  label: string;
  type: ListType;
  icon: IconDefinition;
}

export const listOptions: ListOption[] = [
  {
    label: "Bullet List",
    type: "bulletList",
    icon: faList,
  },
  {
    label: "Ordered List",
    type: "orderedList",
    icon: faListOl,
  },
  {
    label: "Task List",
    type: "taskList",
    icon: faListCheck,
  },
];

export function canToggleList(editor: Editor | null, type: ListType): boolean {
  if (!editor) {
    return false;
  }

  switch (type) {
    case "bulletList":
      return editor.can().toggleBulletList();
    case "orderedList":
      return editor.can().toggleOrderedList();
    case "taskList":
      return editor.can().toggleList("taskList", "taskItem");
    default:
      return false;
  }
}

export function isListActive(editor: Editor | null, type: ListType): boolean {
  if (!editor) return false;

  switch (type) {
    case "bulletList":
      return editor.isActive("bulletList");
    case "orderedList":
      return editor.isActive("orderedList");
    case "taskList":
      return editor.isActive("taskList");
    default:
      return false;
  }
}
